import { CaretDown } from '@carbon/icons-react'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import Container from '@mui/material/Container'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import { iconSizes } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

interface Props {
    subtext: string
    additionalInfo?: string | string[]
}

const StyledContainer = styled(Container)`
    margin-left: ${getPxAsRem(8)};
`

const Subtext: React.FC<Props> = ({ subtext, additionalInfo }: Props) => {
    return (
        <div
            style={{
                display: 'block',
                marginTop: '1rem',
                marginBottom: '1rem',
                alignContent: 'left',
            }}
        >
            {additionalInfo ? (
                <Tooltip
                    title={additionalInfo}
                    sx={{ maxWidth: getPxAsRem(400) }}
                >
                    <>
                        <Typography variant="subtitle1" component="h2">
                            {subtext}
                        </Typography>
                        <StyledContainer>
                            <CaretDown height={iconSizes.smaller} />
                        </StyledContainer>
                    </>
                </Tooltip>
            ) : (
                <Typography variant="subtitle1" component="h2">
                    {subtext}
                </Typography>
            )}
        </div>
    )
}

export default Subtext
